import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function Cogeneration() {
  const [powerplants, setPowerplants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const plantsPerPage = 15; // compact pagination: 10 per page

  useEffect(() => {
    axios
      .get("https://backend-zkgn.onrender.com/api/cogen")
      .then((res) => {
        setPowerplants(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch cogeneration plants:", err);
        setLoading(false);
      });
  }, []);

  const totalPages = Math.ceil(powerplants.length / plantsPerPage);
  const indexOfLast = currentPage * plantsPerPage;
  const indexOfFirst = indexOfLast - plantsPerPage;
  const currentPlants = powerplants.slice(indexOfFirst, indexOfLast);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this cogeneration plant?")) return;
    try {
      await axios.delete(`https://backend-zkgn.onrender.com/api/cogen/${id}`);
      setPowerplants((prev) => prev.filter((plant) => plant.cogen_id !== id));
      toast.success("Plant deleted successfully.");
    } catch (error) {
      console.error("Error deleting plant:", error);
      toast.error("Failed to delete the plant.");
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);

    if (start > 1) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages) pages.push("end-ellipsis");

    return pages;
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="fw-bold text-tertiary mb-2">
          <strong>{powerplants.length}</strong> - Cogeneration Plants Found
        </h5>
        <Link to="/addcogeneration" className="btn btn-primary">
          Add Cogeneration Plant
        </Link>
      </div>

      <div className="row">
        {currentPlants.map((plant) => (
          <div key={plant.cogen_id} className="col-lg-4 col-md-6 mb-4">
            <div className="card h-100 shadow-sm position-relative">
              <div className="card-body">
                <Link className="plant-link" to={`/cogendashboard/${plant.cogen_plant_name.replace(
                    /\s+/g,
                    "-"
                  )}/${plant.cogen_id}`}>
                  <h5 className="card-title fw-bold text-dark">{plant.cogen_plant_name}</h5>
                </Link>
                <p className="mb-1 plantdetails">
                  <strong style={{ color: "#D84D10" }}>Address:</strong> {plant.city}
                </p>
                <p className="mb-0 plantdetails">
                  <strong style={{ color: "#D84D10" }}>Contact:</strong> {plant.phone_number}, {plant.mobile_number}
                </p>
              </div>

              <div className="position-absolute bottom-0 end-0 p-2 d-flex">
                <Link to={`/editcogeneration/${plant.cogen_plant_name.replace(
                    /\s+/g,
                    "-"
                  )}/${plant.cogen_id}`} className="btn btn-link text-success p-0 me-3">
                  <i className="fa fa-edit"></i>
                </Link>
                <button onClick={() => handleDelete(plant.cogen_id)} className="btn btn-link text-danger p-0">
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
        <ToastContainer position="top-center" autoClose={3000} />
      </div>

      {/* Compact Pagination */}
      <div className="pagination-container mt-3">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {getPageNumbers().map((page, index) =>
          page === "start-ellipsis" || page === "end-ellipsis" ? (
            <span key={index} className="ellipsis">
              ...
            </span>
          ) : (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Cogeneration;
